module.exports = __webpack_public_path__ + "img/arrow-up.cfd4a5c1.svg";